import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function TrySquareIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 491.312 491.312">
            <path d="M0,0v491.312h491.312L0,0z M384,451.312v24h-32v-40h-16v40h-32v-24h-16v24h-32v-40h-16v40h-32v-24h-16v24h-32v-40h-16v40
                h-32v-24H96v24H64v-40H48v40H16v-40h24v-16H16v-32h40v-16H16v-32h24v-16H16v-32h40v-16H16v-32h24v-16H16v-32h40v-16H16v-32h24
                v-16H16v-32h40v-16H16V38.624l436.688,436.688H400v-24H384z" />
            <polygon points="80,411.312 208,411.312 208,395.312 96,395.312 96,231.76 259.552,395.312 224,395.312 224,411.312
                298.176,411.312 80,193.136" />
        </SvgIcon>
    );
}
